import { DynamicContent } from "@/components/dynamic-content/DynamicContent";
import { TheyDoModalV2 } from "@/components/TheyDoModal";
import { ModalChoice } from "@/lib/tour/steps/v2/modal";
import { Dialog, DialogContent } from "@/components/intro/Dialog";
import { ShadowDomContainer } from "@/components/ShadowDomContainer";
import styles from "./ModalStep.module.css";
import { cn, isStringNotEmpty } from "@/lib/utils";
import { Logo } from "@/components/Logo";
import { ChoiseButton } from "@/components/PromptCard";

interface MultipleChoiceModalProps {
  title?: string;
  description?: string;
  variant?: string;
  content: string;
  choices: ModalChoice[];
  onSelect: (id: string) => void;
  onClose: () => void;
  onWatermarkClick: () => void;
  showFeedbackButton?: boolean;
}

export function MultipleChoiceModal({
  choices,
  onSelect,
  variant,
  description,
  title,
  content,
  onClose,
  onWatermarkClick,
  showFeedbackButton = true,
}: MultipleChoiceModalProps) {
  if (variant === "theydo") {
    return <TheyDoModalContainer choices={choices} onSelect={onSelect} />;
  }

  const hasTitle = isStringNotEmpty(title);
  const hasContent = isStringNotEmpty(content);

  return (
    <Dialog initialOpen>
      <DialogContent className={styles.contentWrapper}>
        <ShadowDomContainer>
          <div className="pyne-prompt" data-inactive="false">
            <div style={{ display: "flex", flexDirection: "column", gap: 24 }}>
              {hasTitle && <h5 className="pyne-prompt__title">{title}</h5>}
              {hasContent && (
                <div className={cn("pyne-prompt__content", { "pyne-prompt__content--no-title": !hasTitle })}>
                  <DynamicContent is="p" content={content} />
                </div>
              )}
              <div className="pyne-prompt__choices" style={{ display: "flex", gap: "8px", flexWrap: "wrap" }}>
                {choices?.map((choice) => (
                  <ChoiseButton key={choice.id} variant={choice.buttonVariant} onClick={() => onSelect(choice.id)}>
                    {choice.text}
                  </ChoiseButton>
                ))}
              </div>
              {showFeedbackButton && (
                <div className="pyne-prompt__label" onClick={onWatermarkClick} style={{ cursor: "pointer" }}>
                  Share feedback - <Logo style={{ width: 48, height: 16, marginTop: 1 }} />
                </div>
              )}
            </div>
          </div>
        </ShadowDomContainer>
      </DialogContent>
    </Dialog>
  );
}

function TheyDoModalContainer({ choices, onSelect }: { choices: ModalChoice[]; onSelect: (id: string) => void }) {
  return <TheyDoModalV2 choices={choices} onSelect={onSelect} />;
}
